import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { ObjectUrlMediaModal } from "./ObjectUrlMediaModal";
import configs from "../../utils/configs";

const appName = configs.translation("app-name").toLowerCase().replace(/ /g, "-");

let loadingObject = null;

try {
  loadingObject = require(`../../assets/models/LoadingObject_${appName}.glb`);
} catch (e) {
  loadingObject = require("../../assets/models/LoadingObject_app.glb");
}

const isMobile = AFRAME.utils.device.isMobile() || AFRAME.utils.device.isMobileVR();

export function ObjectURLMediaModalContainer({ scene, entry, onSpawn, onClose }) {
  const onSubmit = useCallback(
    ({ href, hideHref, smoothTransition = false }) => {
      scene.emit("add_media", {
        src: entry.url === undefined ? entry : entry.url,
        href,
        hideHref,
        smoothTransition
      });
      onClose();
    },
    [scene, onClose]
  );

  return <ObjectUrlMediaModal entry={entry} isMobile={isMobile} onSubmit={onSubmit} onClose={onClose} />;
}
